import { useState, useRef } from 'react';
import { Row, Col } from 'src/componentes/grid';
import { useIntl } from 'react-intl';
import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import Input from 'src/componentes/input';

const AnexosEtapaEditView = ({ onAttachmentCreated, ...rest }) => {
  const ref = useRef();
  const intl = useIntl();
  const [nomeAnexo, setNomeAnexo] = useState('');

  const handleClose = () => {
    if (ref.current) ref.current.close();
  };

  const handleSave = () => {
    if (!nomeAnexo?.trim()) return;

    const newAnexo = {
      id: crypto.randomUUID(),
      descricao: nomeAnexo.trim(),
      utilizar: false,
      obrigatorio: false,
    };

    if (onAttachmentCreated) {
      onAttachmentCreated(newAnexo);
    }

    handleClose();
  };

  const actions = [
    <Button key={1} onClick={handleClose} color="secondary">
      {intl.formatMessage({ id: 'label.cancelar' })}
    </Button>,
    <Button key={2} className="ml-2" onClick={handleSave}>
      {intl.formatMessage({ id: 'label.salvar' })}
    </Button>,
  ];

  return (
    <Dialog
      ref={ref}
      title={intl.formatMessage({ id: 'anexos' })}
      actions={actions}
      onRequestClose={handleClose}
      minWidth={400}
      {...rest}
    >
      <div className="ml-3 mr-3">
        <Row>
          <Col md={12}>
            <Input
              required
              model={{
                value: nomeAnexo,
                label: intl.formatMessage({ id: 'nomeAnexo' }),
                requestChange: setNomeAnexo,
              }}
            />
          </Col>
        </Row>
      </div>
    </Dialog>
  );
};

export default AnexosEtapaEditView;
